import { useGetCompanies } from '@services/companies'
import { convertTimestampToDuration } from '@shared/innmaxLib/utils/webHelper'
import { useCallback } from 'react'

export const useConvertAirportOperationsRpt = () => {
  const { byId } = useGetCompanies()
  const converter = useCallback(
    (data: any) => {
      return {
        ...data,
        orgSessionName: byId?.[data.orgSessionId]?.name || '-',
      }
    },
    [byId]
  )

  return converter
}

export const useConvertAirportOperationsSummary = () => {
  return (data: any) => {
    return data
      ? {
          ...data,
          chargingDegreeStr: convertTimestampToDuration(
            data.chargingDegree || 0
          ),
          occupationDurationStr: convertTimestampToDuration(
            data.occupationDuration
          ),
        }
      : {}
  }
}
